import { ClientChip, ProjectChip } from '../../../ui/EntityLabel';
import { useClientOptions } from './ClientPicker';

/**
 * Chip klienta (lifting 17.10.2026, `ui/EntityLabel` → `ClientChip`) tam, gdzie lista dostaje tylko id i nazwę
 * klienta (np. wątki poczty): kolor klienta z `clients.options` (wspólna pamięć podręczna pickerów), żeby chip miał
 * tę samą barwę co w Zadaniach i profilu. Bez dostępu do listy klientów — barwa z identyfikatora.
 */
export function ClientLabel({
  client,
  className,
}: {
  client: { id: string; name: string; color?: string | null };
  className?: string;
}) {
  const known = client.color !== undefined;
  const options = useClientOptions({ includeArchived: true, enabled: !known });
  const color = known ? client.color : (options.data?.find((c) => c.id === client.id)?.color ?? null);
  return <ClientChip client={{ id: client.id, name: client.name, color }} className={className} />;
}

/**
 * Chip z samej nazwy (np. „kontekst” w Dziś: klient albo projekt wewnętrzny): nazwa klienta z `clients.options` →
 * chip klienta w jego barwie, inna nazwa (projekt wewnętrzny, workspace) → neutralny chip projektu.
 */
export function ContextLabel({ name, className }: { name: string; className?: string }) {
  const options = useClientOptions({ includeArchived: true });
  const client = options.data?.find((c) => c.name === name);
  return client ? (
    <ClientChip client={client} className={className} />
  ) : (
    <ProjectChip name={name} className={className} />
  );
}
